import { UserContentSummary } from '@/domain/usecases/content/user-content-summary'
import { UserContentRecommended } from '@/domain/usecases/content/user-content-recommended'
import { ContentRecommendationType } from '@/domain/models/content/content-recommendation-type'
import { FeatureFlagName, getFlagValue } from '@/infra/feature-flag'
import { queryClient } from '@/infra/http'
import { importRemote } from '@/main/routes/helpers/loaders'

/**
 * Loads home page data including content summary and recommendations
 * Recommendations are conditionally loaded based on feature flags
 */
export async function loadHome() {
  const [contentSummary, companyRecommendation, userBasedCFRecommendation] = await Promise.all([
    getContentSummary(),
    getCompanyRecommendation(),
    getUserBasedCFRecommendation()
  ])

  return {
    ...contentSummary,
    companyRecommended: companyRecommendation,
    userBasedCFRecommended: userBasedCFRecommendation
  }
}

async function getContentSummary() {
  const remote = await importRemote<UserContentSummary>('makeRemoteUserContentSummary', queryClient)
  return remote.get()
}

async function getCompanyRecommendation() {
  if (!getFlagValue(FeatureFlagName.DISPLAY_COMPANY_CONTENT_RECOMMENDATIONS)) {
    return []
  }

  const recommendationLimit = 3
  const remote = await importRemote<UserContentRecommended>(
    'makeRemoteUserContentRecommended',
    queryClient
  )
  return remote.get(ContentRecommendationType.Enum.COMPANY, recommendationLimit)
}

async function getUserBasedCFRecommendation() {
  if (!getFlagValue(FeatureFlagName.USER_BASED_CF_RECOMMENDATIONS)) {
    return []
  }

  const recommendationLimit = 4
  const remote = await importRemote<UserContentRecommended>(
    'makeRemoteUserContentRecommended',
    queryClient
  )
  return remote.get(ContentRecommendationType.Enum.USER_BASED_CF, recommendationLimit)
}
